import { useUserOrganization } from '@modules-deprecated/app/organization'

import { DMS_ALLOWED_ORGANIZATION_IDS, DMS_ALLOWED_UMBRELLA_IDS } from '../constants/dmsAllowedOrganizations'

export const useIsDmsEnabled = (): boolean => {
  const { organization } = useUserOrganization()

  return (
    organization?.countryId !== 'DK' ||
    DMS_ALLOWED_ORGANIZATION_IDS.includes(organization?.id ?? '') ||
    DMS_ALLOWED_UMBRELLA_IDS.includes(organization?.ownerUmbrellaId ?? '')
  )
}
